<template>
  <div>
    <div class="share-button" @click="generateShareImage"></div>
    <div class="share-modal" v-if="shareModalVisible" @click="onCloseModal">
      <!-- <div class="mask" @click="onCloseModal"></div> -->
      <img :src="shareUrl" style="max-width: 500px; height: auto" />
      <div class="btn-save" v-if="shareUrl" @click.stop="onSave">
        {{ $t("SAVE") }}
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";

import { getShareImage } from "../services/meeting";

export default {
  props: {
    url: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      shareModalVisible: false,
      shareUrl: ""
    };
  },
  mounted() {},
  methods: {
    onCloseModal() {
      this.shareModalVisible = false;
    },
    async generateShareImage() {
      try {
        // if (this.shareUrl) {
        //   this.shareModalVisible = true;
        //   return;
        // }
        const loadingInstance = Loading.service({});
        const res = await getShareImage(this.url, this.params);
        this.$nextTick(() => {
          loadingInstance.close();
        });
        this.shareModalVisible = true;
        this.shareUrl = res.url;
      } catch (error) {
        console.error(error);
      }
    },
    onSave() {
      const url = this.shareUrl;
      fetch(url)
        .then(resp => resp.blob())
        .then(blobobject => {
          const blob = window.URL.createObjectURL(blobobject);
          const anchor = document.createElement("a");
          anchor.style.display = "none";
          anchor.href = blob;
          anchor.download = `${this.params.fileName}.png`;
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(blob);
        })
        .catch(() => console.log("An error in downloadin gthe file sorry"));
    }
  }
};
</script>

<style lang="less" scoped>
.share-button {
  position: fixed;
  right: 40px;
  bottom: 100px;
  z-index: 10;
  width: 80px;
  height: 80px;
  cursor: pointer;
  background: url("../assets/images/meeting/png_share@2x.png") no-repeat center;
  background-size: cover;
}
.share-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 30000;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  padding: 30px 0;
  box-sizing: border-box;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
  .share-box {
    margin: 40px auto;
    text-align: center;
    width: 750px;
    position: relative;
    z-index: 10;
  }
  .btn-save {
    text-align: center;
    width: 156px;
    line-height: 44px;
    background: #2c528a;
    border-radius: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin: 16px auto;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share-button.vue